import { Controller } from "@hotwired/stimulus"

// Top-nav production health dot. Polls the admin's own /status/prod endpoint
// (which server-side pings viracreator.ai/up, cached) and recolors the dot:
// green = up, red = down, slate = checking/unknown.
export default class extends Controller {
  static targets = ["dot", "label"]
  static values  = {
    url:      { type: String, default: "/status/prod" },
    interval: { type: Number, default: 60 } // seconds
  }

  connect() {
    this._check()
    this._timer = setInterval(() => this._check(), this.intervalValue * 1000)
    // Re-check when the tab regains focus so a backgrounded tab isn't stale.
    this._onVisible = () => { if (!document.hidden) this._check() }
    document.addEventListener("visibilitychange", this._onVisible)
  }

  disconnect() {
    clearInterval(this._timer)
    document.removeEventListener("visibilitychange", this._onVisible)
  }

  async _check() {
    try {
      const res  = await fetch(this.urlValue, { headers: { Accept: "application/json" } })
      const data = await res.json()
      this._render(data.up ? "up" : "down")
    } catch {
      this._render("unknown")
    }
  }

  _render(state) {
    // Flash green when healthy, red when not (down or can't-tell). Always pulses
    // so the dot reads as a live heartbeat rather than a static badge.
    const map = {
      up:      { dot: "bg-success", label: "Prod up" },
      down:    { dot: "bg-error",   label: "Prod DOWN" },
      unknown: { dot: "bg-error",   label: "Prod ?" }
    }
    const cfg = map[state] || map.unknown
    if (this.hasDotTarget) {
      this.dotTarget.className = `w-2 h-2 rounded-full ${cfg.dot} animate-pulse`
    }
    if (this.hasLabelTarget) this.labelTarget.textContent = cfg.label
    this.element.title = cfg.label
  }
}
